import React, { useEffect, useState } from 'react';
import TableHeader from './TableParts/TableHeader';
import TableFooter from './TableParts/TableFooter';
import TableBody from './TableParts/TableBody';
import Filters from './Filters';
import TableDiscount from './TableParts/TableDiscount';
import { connect } from 'react-redux';
import {
    cartCartSelector,
    cartFeaturedProductsListSelector,
    cartMainProduct,
    cartTotal,
} from '../redux/selectors/cartSelector';
import { includeExtra } from '../redux/actions/cartAction';
import { useFilters } from '../hooks/useFilters';
import getDiscountAmountByProduct from '../resolvers/getDiscountAmountByProduct';
import { pagesTariffsByProductSelector } from '../redux/selectors/pagesSelectors';
import { productCurrentProductIdSelector } from '../redux/selectors/productSelector';
import { setPageSubtitle } from '../redux/actions/pagesActions';
import { FEATURED_PRODUCTS_PAIR } from '../constants/constants';
import FeaturedProducts from './FeaturedProducts/FeaturedProducts';
import useCartTotals from "../hooks/useCartTotals";

function CommonProductList({
    cart,
    cartMainProduct,
    includeExtra,
    mainProduct,
    tariffListByProduct,
    productCurrentProductId,
    setSubtitle,
    featuredProductsList,
    checkboxExtraPg,
}) {
    useFilters(cartMainProduct, cartMainProduct?.product_id);

    const [services, setServices] = useState(0);

    useEffect(() => {
        if (
            mainProduct?.current_tariff_id &&
            tariffListByProduct[mainProduct?.current_tariff_id] &&
            tariffListByProduct[mainProduct?.current_tariff_id].services
        ) {
            setServices(tariffListByProduct[mainProduct?.current_tariff_id].services);
        }
    }, [mainProduct, tariffListByProduct]);

    const cartTotals = useCartTotals({ productId: mainProduct?.product_id });

    return (
        <section
            className={`section--table section--table--${cart?.currency?.currency?.toLowerCase()}`}
        >
            <Filters product_id={cartMainProduct?.product_id} product={cartMainProduct} />
            <TableHeader />
            <TableBody
                product_id={cartMainProduct?.product_id}
                product={cartMainProduct}
                currency={cart?.currency}
                includeExtra={includeExtra}
                checkboxExtraPg={checkboxExtraPg}
            />
            {(getDiscountAmountByProduct(cartMainProduct, cart?.currancy) > 0 ||
                cartMainProduct?.bonus_amount > 0) && (
                <TableDiscount
                    product_id={cartMainProduct?.product_id}
                    product={cartMainProduct}
                    currency={cart?.currency}
                    services={services}
                    productCurrentProductId={productCurrentProductId}
                    setSubtitle={setSubtitle}
                />
            )}
            {!!featuredProductsList.length &&
                !!FEATURED_PRODUCTS_PAIR[mainProduct?.product_id]?.products?.length && (
                    <FeaturedProducts mainProduct={mainProduct} productTotal={cartTotals.totalWithPromo} />
                )}
            <TableFooter
                product={cartMainProduct}
                product_id={cartMainProduct?.product_id}
                boltPrice={true}
                cartTotals={cartTotals}
            />
        </section>
    );
}

const mapStateToProps = (state) => ({
    cart: cartCartSelector(state),
    mainProductTotal: cartTotal(state),
    cartMainProduct: cartMainProduct(state),
    mainProduct: cartMainProduct(state),
    tariffListByProduct: pagesTariffsByProductSelector(state),
    productCurrentProductId: productCurrentProductIdSelector(state),
    featuredProductsList: cartFeaturedProductsListSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    includeExtra: (value) => dispatch(includeExtra(value)),
    setSubtitle: (value) => dispatch(setPageSubtitle(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommonProductList);
